import Permissions, { usePermissions } from '@app/src/auth/permissions'
import type { TabsProps } from '@app/src/components/Tabs'
import paths from '@app/src/wf-constants/paths'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useIntl } from 'react-intl'

export const SUPPLY_CHAIN_RELATIONS_TAB = 'supply-chain-relations'

/** The tabs shared by the Products page, its Supply chain relations tab and its Due diligence tab. */
const useProductTabs = (): TabsProps['tabs'] => {
  const { formatMessage } = useIntl()
  const { newProductMappingUi } = useFlags()
  const { hasPermission } = usePermissions()

  return [
    { type: 'all', url: paths.productsCollection, label: formatMessage({ id: 'resourceExplorer.product.all' }) },
    {
      type: SUPPLY_CHAIN_RELATIONS_TAB,
      url: paths.mappingNodeCollection,
      label: formatMessage({ id: 'navbar.valueChains' }),
      // The collection behind this tab is gated on sourcing or transparency access, so an account with
      // neither only gets bounced to the forbidden page by following it.
      hidden: !newProductMappingUi || !hasPermission([Permissions.SOURCING_USER, Permissions.TRANSPARENCY_USER]),
    },
    {
      type: 'due-diligence',
      url: paths.productDueDiligence,
      label: formatMessage({ id: 'resourceExplorer.product.dueDiligence' }),
      // Mirrors the collection's own gate, so the tab is never offered to an account the route forbids.
      // Only transparency accounts otherwise reach this page, and they do their due diligence elsewhere.
      hidden: !hasPermission(Permissions.SOURCING_USER),
    },
  ]
}

export default useProductTabs
